import { render, staticRenderFns } from "./upload_cert.vue?vue&type=template&id=7951701e&scoped=true"
import script from "./upload_cert.vue?vue&type=script&lang=js"
export * from "./upload_cert.vue?vue&type=script&lang=js"
import style0 from "./upload_cert.vue?vue&type=style&index=0&id=7951701e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951701e",
  null
  
)

export default component.exports